<ng-container *ngIf="!status">
  <div class="offline-status d-flex flex-row align-items-center">
    <div class="message">
      <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
      {{'main-navigation.internet-status.offline' | translate}}
    </div>
  </div>
</ng-container>
